import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'
import { IProduct } from '@entities/menu/model/types'
import { MenuProduct } from '@entities/menu'


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuProductList',
  props: {
  products: {
    type: Array as PropType<IProduct[]>,
    required: true,
    default: () => []
  }
},
  emits: ['setDetailProduct'],
  setup(__props, { emit }) {

const props = __props





const setDetailProduct = (product: IProduct) => {
  emit('setDetailProduct', product)
}

return { __sfc: true,emit, props, setDetailProduct, MenuProduct }
}

})